import { useBoolean } from 'ahooks'
import { Button, Modal } from 'antd'

import { queryCanUnfreezeApplyApi } from '@eastcoal/api/trade/unfreezeApplyMember/queryCanUnfreezeApply'

import { RemoteTable } from '@eastcoal/common/components/RemoteTable'
import { RemoteTableProps } from '@eastcoal/common/components/RemoteTable/interface'

import { useAccountStatisticContext } from '../../hooks/useContext'
import { DepositUnfreezeButton } from '../DepositUnfreezeButton'

import { FreezeAmountDetail } from './interface'

const freezeColumns: RemoteTableProps<FreezeAmountDetail, null>['columns'] = [
  {
    dataIndex: 'sort',
    title: '序号',
    align: 'center',
    width: 60
  },
  {
    dataIndex: 'title',
    title: '资金冻结项',
    width: 420
  },
  {
    dataIndex: 'type',
    title: '资金类型',
    width: 80
  },
  {
    dataIndex: 'amount',
    title: '冻结金额',
    valueType: 'digit',
    align: 'right'
  },
  {
    dataIndex: 'applyTime',
    title: '冻结时间',
    width: 140
  },
  {
    dataIndex: 'action',
    title: '操作',
    render(_, record) {
      return <DepositUnfreezeButton record={record} />
    }
  }
]

const fetchApi = async () => {
  const res = await queryCanUnfreezeApplyApi()
  return res.map((item, index) => ({ ...item, sort: `${index + 1}` }))
}

export const AccountStatisticWithUnfreezeApplyButton = () => {
  const [open, openActions] = useBoolean(false)
  const { data = {} } = useAccountStatisticContext()
  const btnVisible = (data.freezeAmount ?? 0) > 0

  return (
    <>
      <Modal
        destroyOnHidden
        cancelText='关闭'
        closable={false}
        okButtonProps={{ hidden: true }}
        open={open}
        title='可申请解冻资金'
        width={1000}
        onCancel={openActions.setFalse}
      >
        <RemoteTable
          api={fetchApi}
          columns={freezeColumns}
          pagination={false}
          rowKey='sort'
          scroll={{ y: 488 }}
        />
      </Modal>
      {btnVisible && (
        <Button ghost size='small' onClick={openActions.setTrue}>
          申请解冻
        </Button>
      )}
    </>
  )
}
